import { graphql } from 'gatsby';

import Template from '../../components/Partners/PartnersPage';

export default (props) => Template(props);

// Unfortunately, Gatsby doesn't let us insert JS variables in this template string, so the query below is quite repetitive:
export const query = graphql`
  query PartnersPageQuery {
    page: sanityPartnersPg(_id: { eq: "partnersPg" }) {
      meta: _rawMeta
      title
      body: _rawBody
      featuredPartners {
        name
      }
    }
    categories: allSanityPartnershipCategory {
      nodes {
        title
      }
    }
    types: allSanityPartnershipType {
      nodes {
        title
      }
    }
    partners: allSanityPartner {
      nodes {
        name
        type {
          title
        }
        categories {
          title
        }
        logo {
          asset {
            fluid(maxWidth: 300) {
              ...GatsbySanityImageFluid_noBase64
            }
          }
        }
        body: _rawBody
        links {
          label
          url
          newWindow
        }
      }
    }
  }
`;
